module.exports = __webpack_public_path__ + "static/media/style transfer.4659ed8c.jpg";